<template>
    <v-container class="container" fluid>
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-system-bar height="70px" dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">Station Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>

                <v-tabs centered>
                    <v-tab>General information</v-tab>
                    <v-tab>Contract information</v-tab>
                    <v-tab>Business Interruption</v-tab>
                    <v-tab>Station Tanks</v-tab>
                    <v-tab-item class="pb-10">
                        <v-row class="mx-5" justify="center">
                            <v-col cols="6">
                                <v-text-field label="Station Name" v-model="editedItem.Name" :rules="[
                                    v => !!v || 'Station Name is required'
                                ]" required></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="6">
                                <v-text-field label="Address" v-model="editedItem.Address" required
                                    :rules="[v => !!v || 'Address is required']"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="City" v-model="editedItem.City"
                                    :rules="[v => !!v || 'City is required']"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field label="Province" v-model="editedItem.Province" :rules="[
                                    v => !!v || 'Province is required'
                                ]"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field label="Postal Code" v-model="editedItem.PostalCode"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field label="Geotab ID" v-model="editedItem.StationGeotabID"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-file-input label="Site Map"></v-file-input>
                            </v-col>
                            <v-col cols="3">
                                <v-file-input label="Road Map"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-combobox v-model="editedItem.GeographicalRegion" :items="regions" :item-text="'Region'"
                                    :item-value="'GeographicalID'" :rules="[v => !!v || 'Required']" label="Region"
                                    @change="setRegionData()"></v-combobox>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="editedItem.LocationNumber" label="Location Number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="Principal Region" v-model="principalRegion" disabled></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Invoice Group" v-model="invoiceGroup" disabled></v-text-field>
                            </v-col>
                        </v-row>

                    </v-tab-item>
                    <v-tab-item>
                        <v-row class="mx-5 mt-5" justify="center">
                            
                            <v-col cols="1">
                                <v-switch label="FSCByKms" v-model="editedItem.FSCByKms" hide-actions></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-switch label="Manual Readings" v-model="editedItem.ManualReads" hide-actions></v-switch>
                            </v-col>
                            
                            <v-col cols="1">
                                <v-switch label="USCustomer" v-model="editedItem.USCustomer" hide-actions></v-switch>
                            </v-col>
                            <v-col cols="1">
                                <v-switch label="Flat Rate" v-model="editedItem.FlatRateCheck" hide-actions></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-switch label="Pay Flat Rate" v-model="editedItem.PayFlatRateCheck"></v-switch>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5 mt-5" justify="center">
                            <v-col cols="3">
                                <v-combobox v-model="type" :items="types" :item-text="'Type'" :item-value="'id'"
                                    @change="changeStationType" auto-select-first></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-switch label="Quad" v-model="editedItem.QuadCall" hide-actions></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-switch label="Pump" v-model="editedItem.PumpCall" hide-actions></v-switch>
                            </v-col>
                            
                            <v-col cols="2">
                                <v-switch label="SplitStation" v-model="editedItem.SplitStation" hide-actions></v-switch>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="Contract Station Number"
                                    v-model="editedItem.ContractSiteNum"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox v-model="editedItem.ContractTerminal" :items="terminals" :item-text="'Name'"
                                    :item-value="'id'" label="Contracted Terminal" class="mx-3"
                                    auto-select-first></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field label="MinLoad" v-model="editedItem.MinLoad"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field label="Special Instructions"
                                    v-model="editedItem.SpecialInstructions"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field label="Method of delivery" v-model="editedItem.MOD"></v-text-field>
                            </v-col>
                            <v-col cols="2">

                                <v-combobox v-model="customer" placeholder="Select Customer" class="mx-3" label="Customer"
                                    :items="customers" :item-text="'Name'" :item-value="'id'" @change="selectCustomer"></v-combobox>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <v-row class="mx-5 mt-5" justify="center">
                            <v-col cols="2">
                                <v-switch label="Business Interruption" v-model="editedItem.BusinessInterruption" hide-actions></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Business Start"
                                    v-model="editedItem.BusinessStart"
                                    v-mask="'####-##-## ##:##'"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Business End"
                                    v-model="editedItem.BusinessEnd"
                                    v-mask="'####-##-## ##:##'"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5 mt-5" justify="center">
                            <v-col cols="6">
                                <v-textarea
                                label="Business Comments"
                                    v-model="editedItem.BusinessComments"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <v-row justify="center">
                            <v-col cols="10">
                                <v-data-table dense :headers="headers" :items="tanks">
                                    <!--<template v-slot:item.ProductID="{ item }">
                                        <v-combobox v-model="item.cbx" :items="products" :item-text="'Product'"
                                            :item-value="'ProductID'" class="ml-3" auto-select-first hide-actions
                                            dense></v-combobox>
                                    </template>-->
                                    <template v-slot:item.SitemapTankNum="{ item }">
                                        <v-text-field
                                            type="number"
                                            v-model="item.SitemapTankNum"
                                            style="width: 100px;"
                                            hide-details
                                            dense
                                        ></v-text-field>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>
                <v-container>
                    <v-row class="mb-4" justify="end">
                        <v-btn dark color="secondary" class="mx-5 white--text" @click="validate()">
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn exact dark color="secondary" class="mr-5 white--text" :to="'/catalogs/stations'">
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'StationsForm',
    directives: {
        mask
    },
    data() {
        return {
            stationID: 0,
            defaultItem: {
                Name: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                ContractSiteNum: null,
                ContractTerminal: null,
                USCustomer: null,
                ManualReads: null,
                SpecialInstructions: null,
                GeographicalRegion: null,
                MOD: null,
                FSCByKms: null,
                StationGeotabID: null,
            },
            editedItem: {
                Name: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                ContractSiteNum: null,
                ContractTerminal: null,
                USCustomer: null,
                ManualReads: null,
                SpecialInstructions: null,
                MOD: null,
                Active: null,
                GeographicalRegion: null,
                FSCByKms: null,
                LocationNumber: null,
                FlatRateCheck: null,
                MinLoad: null,
                StationType: null,
                Customer: null,
                PayFlatRateCheck: null,
                PumpCall: null,
                QuadCall: null,
                BusinessInterruption:null,
                BusinessStart:null,
                BusinessEnd:null,
                BusinessComments:null,
                StationGeotabID: null,
            },
            customers: [],
            customer: [],
            products: [],
            invoiceGroup: '',
            principalRegion: '',
            valid: true,
            terminals: [],
            regions: [],
            principalRegions: [],
            invoiceGroups: [],
            headers: [
                { text: 'Tank #', value: 'Tank', width: '10%' },
                { text: 'SitemapTank #', value: 'SitemapTankNum', width: '15%' },
                { text: 'Product', value: 'Product', width: '30%' },
                { text: 'SafePump', value: 'SafePump', width: '15%' },
                { text: 'SafeFill', value: 'SafeFill', width: '15%' },
                { text: 'Capacity', value: 'Capacity', width: '15%' },
            ],
            tanks: [],
            type: [],
            types: [
                { id: 1, Type: "Contracted" },
                { id: 2, Type: "Private" },
                { id: 3, Type: "Interplant" }
            ]
        };
    },
    mounted() {
        this.loadCustomers();
        this.loadProducts();
        this.loadTerminals();
        this.loadGeographicalRegions();
        this.loadInvoiceGroup();
    },
    methods: {
        selectCustomer: function () {
                this.editedItem.Customer = this.customer.id;
                console.log(this.customer);
        },
        loadCustomers: function () {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadStationData: function () {
            this.stationID = this.$store.state.editedStation.id;
            var str = this.$store;
            if (this.stationID != 0) {

                this.loadTanks();
                axios
                    .get('station/info/' + this.stationID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        this.editedItem = await Object.assign(
                            {},
                            response.data.data[0]
                        );
                        console.log(response.data.data[0])
                        if (response.data.data[0].ContractTerminal != null || response.data.data[0].ContractTerminalName != null) {
                            var terminalIndex = this.terminals.findIndex(elm => {
                                return elm.id == this.editedItem.ContractTerminal;
                            });
                            this.editedItem.ContractTerminal = this.terminals[terminalIndex]

                            console.log(this.editedItem.ContractTerminal);
                        } else {
                            this.editedItem.ContractTerminal = "";
                        }
                        var idx = this.types.findIndex(elm => {
                            return elm.id == this.editedItem.StationType;
                        });
                        console.log(idx);
                        this.type = this.types[idx];
                        var index = this.regions.findIndex(elm => {
                            return elm.GeographicalID == this.editedItem.GeographicalRegion;
                        });
                        console.log(this.editedItem.GeographicalRegion);
                        this.editedItem.GeographicalRegion = this.regions[index];

                        var idxCust = this.customers.findIndex(x => {
                            return x.id == this.editedItem.Customer;
                        });

                        this.customer = this.customers[idxCust];

                        var regionIndex = this.principalRegions.findIndex(elm => {
                            return elm.PrincipalRegionID == this.editedItem.GeographicalRegion.PrincipalRegionID;
                        });
                        if (regionIndex >= 0) {
                            this.principalRegion = this.principalRegions[regionIndex].PrincipalRegion;

                            var invoiceIndex = this.invoiceGroups.findIndex(elm => {
                                return elm.InvoiceGroupID == this.editedItem.GeographicalRegion.InvoiceGroupID;
                            });
                            this.invoiceGroup = this.invoiceGroups[invoiceIndex].InvoiceGroup
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });

                this.$store.state.editedStation.id = 0;
            }
        },
        newStation: function () {
            console.log(this.editedItem);
            this.editedItem.Active = true;
            var str = this.$store;
            if (this.editedItem.ContractTerminal != null) {
                this.editedItem.ContractTerminal = this.editedItem.ContractTerminal.id;
            }
            this.editedItem.GeographicalRegion = this.editedItem.GeographicalRegion.GeographicalID;

            axios
                .post('station', this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New station added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/stations');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        editStation: function () {
            var str = this.$store;
            if (this.editedItem.ContractTerminal != null) {
                this.editedItem.ContractTerminal = this.editedItem.ContractTerminal.id;
                delete this.editedItem['ContractTerminalName'];
            }
            delete this.editedItem['id'];
            this.editedItem.GeographicalRegion = this.editedItem.GeographicalRegion.GeographicalID;
            console.log(this.editedItem);
            axios
                .put('station/' + this.stationID, this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Station information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/stations');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        saveSitemapTankNum: async function () {
            console.log(this.tanks);
            var str = this.$store;
            let numOfTanks = this.tanks.length;
            let counter = {};
            for (let tk of this.tanks) {
                if (tk.SitemapTankNum == null) {
                    str.dispatch('setSnackbar', {
                        color: 'warning',
                        text: 'Sitemap Tank Num cannot be empty.'
                    });
                    return false;
                } else if (Number(tk.SitemapTankNum) < 0) {
                    str.dispatch('setSnackbar', {
                        color: 'warning',
                        text: 'Sitemap Tank Num cannot be a negative value.'
                    });
                    return false;
                } else if (Number(tk.SitemapTankNum) > numOfTanks) {
                    str.dispatch('setSnackbar', {
                        color: 'warning',
                        text: 'This site has only ' + numOfTanks + ' tanks.'
                    });
                    return false;
                }
            }
            console.log(counter);
            for (let tk = 0; tk < this.tanks.length; tk++) {
                if (counter[Number(this.tanks[tk].SitemapTankNum)] !== undefined) {
                    str.dispatch('setSnackbar', {
                        color: 'warning',
                        text: 'There cannot be repeated Sitemap Tanks.'
                    });
                    return false;
                } else {
                    counter[Number(this.tanks[tk].SitemapTankNum)] = true;
                }
            }
            console.log(this.tanks);

            let params = {
                Tanks: [],
            };
            for (let tk of this.tanks) {
                params.Tanks.push({
                    Id: tk.id,
                    SitemapTankNum: Number(tk.SitemapTankNum),
                });
            }

            await axios
                .put('tank/update/sitemap-tank-num', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                })
                .catch(function(error) {
                    console.log(error);
                });

            return true;
        },
        save: async function () {
            let success = await this.saveSitemapTankNum();
            console.log(success);

            if (this.stationID > 1) {
                this.editStation();
            } else {
                this.newStation();
            }
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text:
                        'You have incorrect fields, check again.'
                });
                console.log(this.editedItem.FSCByKms)
                this.$refs.form.validate();
            } else {
                if(this.customer === null){
                    this.editedItem.Customer = null;
                }
                console.log(this.editedItem.FSCByKms)
                this.save();
            }
        },
        loadTerminals: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadPrincipalRegions: function () {

            var str = this.$store;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.principalRegions = response.data;
                    this.loadStationData();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

        },
        loadGeographicalRegions: function () {
            var str = this.$store;
            axios
                .get('geo-region', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    this.loadPrincipalRegions();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadInvoiceGroup: function () {
            var str = this.$store;
            axios
                .get('invoice-group', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.invoiceGroups = response.data;
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        setRegionData: function () {
            console.log(this.editedItem.GeographicalRegion)
            var regionIndex = this.principalRegions.findIndex(elm => {
                return elm.PrincipalRegionID == this.editedItem.GeographicalRegion.PrincipalRegionID;
            });

            this.principalRegion = this.principalRegions[regionIndex].PrincipalRegion;

            var invoiceIndex = this.invoiceGroups.findIndex(elm => {
                return elm.InvoiceGroupID == this.editedItem.GeographicalRegion.InvoiceGroupID;
            });
            this.invoiceGroup = this.invoiceGroups[invoiceIndex].InvoiceGroup;
        },
        changeStationType: function () {
            this.editedItem.StationType = this.type.id;
        },
        loadTanks: function () {
            var str = this.$store;
            axios
                .get('tank/station/' + this.$store.state.editedStation.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.tanks = response.data.data;
                    this.tanks.forEach(async tank => {
                        const idx = await this.products.findIndex(x => {
                            return x.ProductID == tank.ProductID;
                        });
                        console.log(idx);
                        tank.cbx = this.products[idx];
                    });
                    console.log(this.tanks);
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

        },
        loadProducts: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('product', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data.data;
                    console.log(this.products);
                    this.loadTanks();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
    }
};
</script>
